import validate from "/home/runner/work/guardiann-homepage/guardiann-homepage/node_modules/nuxt/dist/pages/runtime/validate.js";
import redirect_45global from "/home/runner/work/guardiann-homepage/guardiann-homepage/middleware/redirect.global.js";
import manifest_45route_45rule from "/home/runner/work/guardiann-homepage/guardiann-homepage/node_modules/nuxt/dist/app/middleware/manifest-route-rule.js";
export const globalMiddleware = [
  validate,
  redirect_45global,
  manifest_45route_45rule
]
export const namedMiddleware = {
  auth: () => import("/home/runner/work/guardiann-homepage/guardiann-homepage/middleware/auth.js"),
  guest: () => import("/home/runner/work/guardiann-homepage/guardiann-homepage/middleware/guest.js"),
  "sanctum:auth": () => import("/home/runner/work/guardiann-homepage/guardiann-homepage/node_modules/nuxt-auth-sanctum/dist/runtime/middleware/sanctum.auth.js"),
  "sanctum:guest": () => import("/home/runner/work/guardiann-homepage/guardiann-homepage/node_modules/nuxt-auth-sanctum/dist/runtime/middleware/sanctum.guest.js")
}